import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Customer-facing pages
import LandingPage from "@/pages/LandingPage";
import QuizPage from "@/pages/QuizPage";
import ResultsPage from "@/pages/ResultsPage";
import EmbedQuiz from "@/pages/EmbedQuiz";

// Admin pages
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminSystems from "@/pages/admin/AdminSystems";
import AdminConditions from "@/pages/admin/AdminConditions";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminProtocols from "@/pages/admin/AdminProtocols";
import AdminQuizQuestions from "@/pages/admin/AdminQuizQuestions";
import AdminAnswerRules from "@/pages/admin/AdminAnswerRules";
import AdminResultTemplates from "@/pages/admin/AdminResultTemplates";
import AdminEmails from "@/pages/admin/AdminEmails";
import AdminImport from "@/pages/admin/AdminImport";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";
import AdminResponses from "@/pages/admin/AdminResponses";
import AdminProtocolBuilder from "@/pages/admin/AdminProtocolBuilder";
import AdminCrossSell from "@/pages/admin/AdminCrossSell";
import AdminEmbedGuide from "@/pages/admin/AdminEmbedGuide";
import AdminDocumentation from "@/pages/admin/AdminDocumentation";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Customer-facing routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/quiz" element={<QuizPage />} />
          <Route path="/results" element={<ResultsPage />} />
          
          {/* Embeddable routes (for iframe/Shopify) */}
          <Route path="/embed" element={<EmbedQuiz />} />
          <Route path="/embed/quiz" element={<EmbedQuiz />} />
          
          {/* Admin routes */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="systems" element={<AdminSystems />} />
            <Route path="conditions" element={<AdminConditions />} />
            <Route path="products" element={<AdminProducts />} />
            <Route path="protocols" element={<AdminProtocols />} />
            <Route path="quiz-questions" element={<AdminQuizQuestions />} />
            <Route path="answer-rules" element={<AdminAnswerRules />} />
            <Route path="result-templates" element={<AdminResultTemplates />} />
            <Route path="emails" element={<AdminEmails />} />
            <Route path="import" element={<AdminImport />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="analytics" element={<AdminAnalytics />} />
            <Route path="responses" element={<AdminResponses />} />
            <Route path="protocol-builder" element={<AdminProtocolBuilder />} />
            <Route path="protocol-builder/:protocolId" element={<AdminProtocolBuilder />} />
            <Route path="cross-sell" element={<AdminCrossSell />} />
            <Route path="embed-guide" element={<AdminEmbedGuide />} />
            <Route path="documentation" element={<AdminDocumentation />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
